// extracted by mini-css-extract-plugin
export default {"tab_component":"LinesTab_tab_component__ceujW","tab_div":"LinesTab_tab_div__PB97i","tab-detail":"LinesTab_tab-detail__Kd9wE","tab_detail_active":"LinesTab_tab_detail_active__rhiXh"};